// Frontend application constants — values safe to expose in the browser bundle.
// Environment-sensitive values (API keys, endpoints) stay in src/config.js.
//
// SECURITY: Everything in this file is visible to any browser visitor.
// Never add secret keys, DB strings, or backend-only credentials here.
// See docs/decisions/0001-stripe-only-payouts.md for context on PAYPAL_PAYOUTS_ENABLED.

// ---------------------------------------------------------------------------
// Feature Flags
// ---------------------------------------------------------------------------

// PAYPAL PAYOUTS DISABLED — See docs/decisions/0001-stripe-only-payouts.md
// Code retained for fast re-enable. Set PAYPAL_PAYOUTS_ENABLED: true in both
// this file AND com.dattebayolabs.api/src/config/constants.js to restore.
export const PAYPAL_PAYOUTS_ENABLED = false;

// GUEST_CHECKOUT_ENABLED: mirrors backend flag.
// See docs/decisions/0002-disable-guest-checkout-and-gate-payments.md
// IMPORTANT: When flipping, also update com.dattebayolabs.api/src/config/constants.js
export const GUEST_CHECKOUT_ENABLED = false;

// ---------------------------------------------------------------------------
// Platform Fee Structure (identical across all environments)
// ---------------------------------------------------------------------------

/** Seller's share of each sale (90%). Platform keeps 10%. */
export const SELLER_MARKET_RATE = 0.90;

/** Minimum platform profit per transaction ($1.00). */
export const MINIMAL_PROFIT = 1.00;

/** Fee to upgrade shipment to tracked/insured ($5.50). */
export const TRACKING_UPGRADE_FEE = 5.50;

/** Orders at or above this amount qualify for free shipping ($10). */
export const FREE_SHIPPING_THRESHOLD = 10;

/** Orders at or above this amount require tracked shipping ($50). */
export const TRACKING_REQUIRED_THRESHOLD = 50;

/** Flat shipping fee for orders below FREE_SHIPPING_THRESHOLD ($1.00). */
export const FLAT_SHIPPING_FEE = 1.00;

/** Platform transaction fee per order ($0.50). */
export const TRANSACTION_FEE = 0.50;

/** Minimum listing price to be eligible for Share & Earn referrals ($10). */
export const SHARE_MIN_PRICE = 10;

/** Share & Earn withdrawal fee ($0.25). */
export const WITHDRAWAL_FEE = 0.25;

// ---------------------------------------------------------------------------
// Escrow / Payout Timing
// ---------------------------------------------------------------------------

/** Days after shipping before escrow auto-releases to seller. */
export const AUTO_RELEASE_DAYS = 14;

// ---------------------------------------------------------------------------
// Image Upload Config
// ---------------------------------------------------------------------------

/** JPEG compression quality (0–1) applied to uploaded images. */
export const IMAGE_COMPRESSION = 0.6;

/** Maximum width (px) images are resized to on upload. */
export const MAX_IMAGE_WIDTH = 600;

/** Minimum acceptable width (px) for uploaded images. */
export const MIN_IMAGE_WIDTH = 400;

/** Maximum file size for image uploads (10 MB). */
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

/** Accepted MIME types for image uploads. */
export const ACCEPTED_UPLOAD_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

// ---------------------------------------------------------------------------
// Storage Keys
// ---------------------------------------------------------------------------

/** localStorage key for beta access gate. */
export const BETA_STORAGE_KEY = 'primal_beta_access';
